export const MicroappTypeDecorator = {
  url() {
    return `signup-hubspot/microapp`;
  },

  query() {
    return {};
  }

};